import BaseTypeController from "vamos/cockpit/base/controller/BaseTypeController";
import Dialog from "sap/m/Dialog";
import { ODataListBinding$DataReceivedEvent } from "sap/ui/model/odata/v4/ODataListBinding";
import JSONModel from "sap/ui/model/json/JSONModel";
import Input, { Input$SubmitEvent } from "sap/m/Input";
import { showSuccess } from "vamos/cockpit/base/handler/MessageToastHandler";
import ApiService from "vamos/cockpit/base/services/type/ApiService";
import { ceilValue } from "vamos/cockpit/util/NumberUtil";
import { ResponseContactDto, ResponseStockExtractionResultDto } from "vamos/cockpit/model/api/vamos.private.api.types";
import { Article } from "vamos/cockpit/model/odata/VamosModel";
import { Button$PressEvent } from "sap/m/Button";

/**
 * @namespace vamos.cockpit.data.shopping-cart.controller
 */
export default class StockExtractionDialogController extends BaseTypeController {
    private dialog: Dialog;
    private dialogModel: JSONModel;
    private uncoveredPositionsDialog: Dialog;
    private saveCallBack: () => void;

    public onInit(): void {
        super.onInit();
        this.dialog = this.getView().byId("stockExtractionDialog") as Dialog;
        this.dialogModel = new JSONModel();
        this.dialog.setModel(this.dialogModel, "dialogModel");

    }

    public openDialog(saveCallBack: () => void): void {
        this.saveCallBack = saveCallBack;
        this.resetDialogData();
        this.dialog.open();
        this.getView().byId("stockExtractionTable").getBinding("items").refresh();
    }


    private onCloseDialog(): void {
        this.dialog.close();
    }

    private resetDialogData(): void {
        this.dialogModel.setData({
            installerNumber: "",
            uncoveredPositions: [],
        });

        this.viewModel.setData({
            hideMessageStrip: true,
            isValidUser: false,
        });

    }

    public ceilValue(value: number): string | null {
        return ceilValue(value);
    }

    public onShoppingCartsReceived(event: ODataListBinding$DataReceivedEvent) {
        const iCount = event.getSource().getCount();
        this.viewModel.setProperty("/ShoppingCartCount", iCount);
    }

    public async loadDialog() {
        if (!this.uncoveredPositionsDialog) {
            const dialogControl = await this.loadFragment({ name: "vamos.cockpit.data.shopping-cart.fragment.BookUncoveredPositionsDialog", addToDependents: true });
            if (Array.isArray(dialogControl)) {
                this.uncoveredPositionsDialog = dialogControl[0] as Dialog;
            } else {
                this.uncoveredPositionsDialog = dialogControl as Dialog;
            }
            this.uncoveredPositionsDialog.setModel(this.dialogModel, "dialogModel");
        }
        return this.uncoveredPositionsDialog;

    }

    public async onBook(): Promise<void> {
        const customerNumber = this.dialogModel.getProperty("/installerNumber") as string;
        const response = await ApiService.getInstance().postRestJsonDataWithoutMessage<ResponseStockExtractionResultDto>(`/shopping-cart/extract/${customerNumber}`, {});

        if (response.success && response.data?.content?.uncoveredPositions.length > 0) {
            this.dialogModel.setProperty("/uncoveredPositions", response.data.content.uncoveredPositions);
            const dialog = await this.loadDialog();
            dialog.open();
            return;
        }
        showSuccess(this.getText("EntrySaved"));
        this.saveCallBack();
        this.onCloseDialog();
    }

    public async onSubmitInstallerNumber(): Promise<void> {
        const input = this.getView().byId("installerNumberInput") as Input;
        const installerNumber = input.getValue().trim();

        let text = "";
        if (installerNumber === "") {
            this.setIsValidUser(false);
            this.setValidCustomerText(text);
            return;
        }
        const response = await ApiService.getInstance().getRestJsonDataWithoutMessage<ResponseContactDto>(`/shopping-cart/${installerNumber}`);
        if (response.success) {
            const dto = response.data?.content;
            let email = dto.email ?? "";
            if (email === "") {
                email = "-";
            }
            text = this.getText("NameLabel", [dto.name]) + "\n" + this.getText("EmailLabel", [email]);
        } else {
            text = this.getText("NoValidInstaller");
            this.viewModel.setProperty("/isValidCustomerText", this.getText("NoValidInstaller"));
        }
        this.setValidCustomerText(text);
        this.setIsValidUser(response.success);

    }

    private setIsValidUser(isValidUser: boolean) {
        this.viewModel.setProperty("/isValidUser", isValidUser);
    }

    private setValidCustomerText(text: string) {
        this.viewModel.setProperty("/isValidCustomerText", text);
    }
}
